import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/login/LoginView.vue'
import CertificateListView from '@/views/certificate-list/CertificateListView.vue'
import ImportHistoryView from '@/views/import-history/ImportHistoryView.vue'
import CertificateQueryView from '@/views/certificate-query/CertificateQueryView.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/certificates',
    name: 'certificates',
    component: CertificateListView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/import-history',
    name: 'importHistory',
    component: ImportHistoryView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/certificate-query',
    name: 'certificateQuery',
    component: CertificateQueryView,
    meta: {
      requiresAuth: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL || '/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否登录
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
    if (!isLoggedIn) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router